export const ACTION = {
  CREATE: "CREATE",
  REFRESH: "REFRESH",
  DELETE: "DELETE",
  SHARE: "SHARE",
  VIEW: "VIEW",
};

export const ROLE = {
  CCS: "Cross Check Sheet",
  INSTANCE: "Google Sheet",
};
